// src/components/LoginButton.tsx
import React from "react";
import { useMsal } from "@azure/msal-react";
import { InteractionType } from "@azure/msal-browser";

const LoginButton: React.FC = () => {
  const { instance } = useMsal();

  const handleLogin = () => {
    instance.loginPopup({
      scopes: ["User.Read", "openid", "profile"]  // request basic scopes and MS Graph scope
    }).catch(error => {
      console.error("Login failed:", error);
    });
  };

  return <button className="sign-out" onClick={handleLogin}>Sign In</button>;
};

export default LoginButton;